<template>
    <div>
        <v-app-bar
            extension-height="80"
            elevation="0"
            min-height="80"
            color="#f2f1f7"
        >
            <v-toolbar-title class="my-10" style="background: inherit">
            <p class="font-weight-bold text-capitalize mb-0">
                <img
                src="../../public/assets/trigma-logo.svg"
                alt=""
                >
            </p>
            </v-toolbar-title>
            <v-spacer />
        </v-app-bar>
        <v-container class="d-flex justify-center flex-column align-center" style="height: 80vh">
            <v-progress-circular
            :width="4"
            size="70"
            color="blue"
            indeterminate
            />
            <h2 class="titleText--text mt-5">
            Loading your workstation
            </h2>
        </v-container>
    </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import apifactory from '../apis/apifactory';
Vue.use(VueAxios, axios);
export default {
    name: "ExtraAuth",
    data: () => ({
        loginusername: null,
        loginusernametbd: null,
        userid: null,
        itemObj: null,
        msg:''

    }),
    props: {
        user_id: {
            type: String,
            required: true,
            default: null
        },
        key: {
            type: String,
            required: true,
            default: null
        },
        app_id: {
            type: String,
            required: true,
            default: null
        }
    },
    mounted() {
        //window.localStorage.clear();
        this.checkauth();
    },
    methods: {
        checkauth() {

            this.getauthdata();
            this.loginusername = "";
            
        },
        getauthdata() {
            apifactory.userExtraAthenticate(this.user_id, this.key, this.app_id)
                .then((res) => {
            

                    if (res.status != 200) {
                        alert(res.data.message);

                    } else {
                              this.itemObj = res.data;
                        this.loginusername = res.data.username;
                        this.userid = res.data.user_id;
                        localStorage.setItem('SET_USERNAME', this.loginusername);
                        localStorage.setItem('SET_USERID', this.userid);
                        if(res.data.status >0){
                      
                       this.$router.push("/dashboard");
                        }else
                        {
            
                               this.$router.push("/noaccess");
                        }
                       
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        goTo(url) {
            return this.$router.push(url);
        }
    }

};
</script>
